<div class="collapsible-panel">
    <div class="top-panel">
        <!-- Select All Checkbox -->
        <mat-checkbox class="select-all" [(ngModel)]="domain.allComplete" (change)="onSelectAllChange()"
            [attr.aria-label]="domain.name">
            {{ domain.name }}
        </mat-checkbox>

        <!-- Collapsible Icon using Material Icon -->
        <button class="collapsible-icon" mat-icon-button (click)="togglePanel()"
            [attr.aria-label]="domain.name"
            [attr.aria-expanded]="isPanelOpen"
            aria-controls="collapsible-content">
            <mat-icon>{{ isPanelOpen ? 'expand_more' : 'expand_less' }}</mat-icon>
        </button>
    </div>

    <!-- Collapsible Panel Content -->
    <div [class.panel]="true" [class.open]="isPanelOpen" id="collapsible-content">
        <!-- Child Checkboxes -->
        <div class="checkbox-group">
            <fieldset>
                <legend class="sr-only">{{domain.name}}</legend>
                <mat-checkbox *ngFor="let item of domain.subtasks" class="child-checkbox" [(ngModel)]="item.checked"
                    (change)="onChildCheckboxChange()" [attr.aria-label]="item.name">
                    {{ item.name }}
                </mat-checkbox>
            </fieldset>
        </div>
    </div>
</div>